import React from 'react';

function ProductTitle({ name, classes = '' }: Readonly<{ name: string; classes?: string }>) {
  return (
    <div className={`product-title hmf-mb-xs ${classes}`} data-testid="quickViewModalName">
      <p id="ProductTitle-title" className="hmf-header-bold-s label-base hmf-m-0">
        {name}
      </p>
    </div>
  );
}

export default ProductTitle;
